export default __webpack_public_path__ + "static/media/carousel-blueribbonbags.6e6fb8ee.jpg";